<template>
  <div class="main">
    <div
      style="height:120px;font-size:40px;font-weight:bold;text-align:center;padding-top:5px;letter-spacing:5px;line-height:120px"
    ></div>
    <div class="home" @click="gohome"></div>
    <div class="chart1" v-if="false">
      <div class="myChart">
        <div id="myChart1" style="height:260px;width:100%"></div>
      </div>
    </div>
    <div class="chart1" v-if="false">
      <span>{{ year }}</span>
      <span>年</span>
      <span>{{ month }}</span>
    </div>
    <div class="chart2" v-if="true"></div>
    <div class="chart2" v-if="false">
      <el-row>
        <el-col style="width:100px">环境污染罪</el-col>
        <el-col style="width:300px;">
          <svgprogress type="rect" :options="options" value="65"></svgprogress>
        </el-col>
        <el-col style="width:50px">983</el-col>
        <el-col style="width:100px">生产、销售劣药罪</el-col>
        <el-col style="width:300px;">
          <svgprogress type="rect" :options="options" value="65"></svgprogress>
        </el-col>
        <el-col style="width:50px">983</el-col>
      </el-row>
      <el-row>
        <el-col style="width:100px">环境污染罪</el-col>
        <el-col style="width:300px;">
          <svgprogress type="rect" :options="options" value="65"></svgprogress>
        </el-col>
        <el-col style="width:50px">983</el-col>
        <el-col style="width:100px">生产、销售劣药罪</el-col>
        <el-col style="width:300px;">
          <svgprogress type="rect" :options="options" value="65"></svgprogress>
        </el-col>
        <el-col style="width:50px">983</el-col>
      </el-row>
      <el-row>
        <el-col style="width:100px">环境污染罪</el-col>
        <el-col style="width:300px;">
          <svgprogress type="rect" :options="options" value="65"></svgprogress>
        </el-col>
        <el-col style="width:50px">983</el-col>
        <el-col style="width:100px">生产、销售劣药罪</el-col>
        <el-col style="width:300px;">
          <svgprogress type="rect" :options="options" value="65"></svgprogress>
        </el-col>
        <el-col style="width:50px">983</el-col>
      </el-row>
      <el-row>
        <el-col style="width:100px">环境污染罪</el-col>
        <el-col style="width:300px;">
          <svgprogress type="rect" :options="options" value="65"></svgprogress>
        </el-col>
        <el-col style="width:50px">983</el-col>
        <el-col style="width:100px">生产、销售劣药罪</el-col>
        <el-col style="width:300px;">
          <svgprogress type="rect" :options="options" value="65"></svgprogress>
        </el-col>
        <el-col style="width:50px">983</el-col>
      </el-row>
      <!-- <div id="myChart2" style="height:260px;width:100%"></div> -->
    </div>
    <div class="chart3" v-if="false">
      <el-row type="flex" style="margin-right:30px;margin-top:30px;">
        <el-col>
          <svgprogress type="circle" :options="options3" value="22"></svgprogress>
          <div>行政强制</div>
        </el-col>
        <el-col>
          <svgprogress type="circle" :options="options3" value="22"></svgprogress>
          <div>行政检查</div>
        </el-col>
        <el-col>
          <svgprogress type="circle" :options="options3" value="22"></svgprogress>
          <div>行政许可</div>
        </el-col>
        <el-col>
          <svgprogress type="circle" :options="options3" value="22"></svgprogress>
          <div>行政奖励</div>
        </el-col>
        <el-col>
          <svgprogress type="circle" :options="options3" value="22"></svgprogress>
          <div>行政处罚</div>
        </el-col>
      </el-row>
      <div class="chart3part2">
        <el-row type="flex">
          <el-col style="margin-left:10px;">
            <svgprogress type="circle" :options="options3" value="22"></svgprogress>
            <div>行政强制措施</div>
          </el-col>
          <el-col style="margin-left:70px;">
            <svgprogress type="circle" :options="options3" value="22"></svgprogress>
            <div>行政强制执行</div>
          </el-col>
          <el-col style="margin-left:70px;">
            <svgprogress type="circle" :options="options3" value="22"></svgprogress>
            <div>行政监督检查</div>
          </el-col>
          <el-col style="margin-left:70px;">
            <svgprogress type="circle" :options="options3" value="22"></svgprogress>
            <div>其他行政权力</div>
          </el-col>
        </el-row>
      </div>
    </div>
    <div class="chart4" v-if="false">
      <div id="myChart4" style="height:100%;width:100%"></div>
    </div>
    <div class="chart5" v-if="false">
      <div id="myChart5" style="height:100%;width:100%"></div>
    </div>
    <div class="chart6" v-if="false">
      <div id="myChart6" style="height:100%;width:100%"></div>
    </div>
    <div class="chart7" v-if="false">
      <div id="myChart7" style="height:100%;width:100%"></div>
    </div>
    <div class="chart8" v-if="false">
      <div id="myChart8" style="height:100%;width:100%"></div>
    </div>
    <!-- 统计渠道数量 -->
    <div class="statistics_number" id="statistics_number"></div>
    <div class="statistics_numberleft" id="statistics_numberleft"></div>

    <!-- 公益诉讼风采视频 -->
    <div class="video">
      <div id="certify">
        <div class="swiper-container">
          <div class="swiper-wrapper">
            <div class="swiper-slide">
              <img
                :src="imgs.tllj"
                style="width:460px;height:368px;border-radius: 10px;"
                @mouseover="changeVideo(urls.tllj)"
              />
            </div>
            <div class="swiper-slide">
              <img
                :src="imgs.fpw"
                style="width:460px;height:368px;border-radius: 10px;"
                @mouseover="changeVideo(urls.fpw)"
              />
            </div>
            <div class="swiper-slide">
              <img
                :src="imgs.gyxzs"
                style="width:460px;height:368px;border-radius: 10px;"
                @mouseover="changeVideo(urls.gyxzs)"
              />
            </div>

            <div class="swiper-slide">
              <img
                :src="imgs.xcp"
                style="width:460px;height:368px;border-radius: 10px;"
                @mouseover="changeVideo(urls.xcp)"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 播放按钮 -->
    <i
      :class="pauseIcon"
      style="position:absolute;font-size:80px;left:480px;top:730px;z-index:99999;cursor:pointer"
      @click="pauseClick"
    ></i>

    <!-- 视频弹框 -->
    <dialog
      :open="commandShow"
      style="position:absolute;width:2880px;height:1080px;top:0px;z-index:9999;background:transparent;border:none;"
    >
      <div class="input_video" style="width:1080px;height:720px;margin-left:900px;margin-top:180px">
        <video-player :options="playerOptions"></video-player>
      </div>
    </dialog>
  </div>
</template>

<script>
import G2World from "./g2world.vue";
import svgprogress from "svg-progress-bar";
export default {
  name: "Index",
  components: {
    G2World,
    svgprogress
  },
  data() {
    return {
      imgs: {
        fpw: require("../assets/video_img/fanghuwang.png"),
        gyxzs: require("../assets/video_img/gyxzs.png"),
        xcp: require("../assets/video_img/xcp.png"),
        tllj: require("../assets/video_img/tllj.png")
      },
      urls: {
        fpw: "http://114.115.151.83/law-eye-static/gyss/fangpaowang.mp4",
        gyxzs: "http://114.115.151.83/law-eye-static/gyss/gyxzs.mp4",
        xcp: "http://114.115.151.83/law-eye-static/gyss/xcp.mp4",
        tllj: "http://114.115.151.83/law-eye-static/gyss/jialaohu.mp4"
      },
      serverData: [],
      options: {
        rectRadius: 8,
        gradientColor: ["rgb(114, 150, 236)", "rgb(83,233, 222)"],
        varyStrokeArray: [30, 25],
        textColor: "rgba(0,0,0,0)",
        pathColors: ["#6387ae", "#0a2e48"]
      },
      options3: {
        pathColors: ["#1b475c", "#54e8df"],
        textColor: "#FFF"
      },
      year: "2019",
      month: "09",
      day: "17",
      time: "21:46:00",
      isActive: -1,
      pic_src: require("../assets/img/pic01.jpg"),
      case_list_name: "大型案件名称",
      playerOptions: {},
      pauseIcon: "el-icon-video-play",
      commandShow: false
    };
  },
  props: {},
  mounted: function() {
    // 统计渠道数量
    this.statistics_number();
    this.buttle();
    this.rideo();
    //this.myChart1();
    //this.myChart2();
    //this.myChart3();
    //this.myChart4();
    // this.myChart5();
    // this.myChart6();
    //this.myChart7();
    //this.myChart8();
  },
  methods: {
    //  气泡图
    buttle() {
      Highcharts.chart("statistics_numberleft", {
        chart: {
          type: "packedbubble",
          // height: "100%",
          height: 330,
          marginTop: 0,
          marginBottom: 0,
          backgroundColor: "rgba(5,32,55,0.1)"
        },
        colors: [
          "#bf8e95",
          "#409db1",
          "#5da4d6",
          "#c26886",
          "#8971b0",
          "#60bfa0",
          "#6a76b7"
        ],
        title: {
          text: null
        },
        legend: {
          enabled: false //不显示图例
        },
        pane: {
          size: "100%"
        },
        credits: {
          enabled: false //不显示LOGO
        },
        tooltip: {
          useHTML: true,
          pointFormat: "<b>{point.y}</b>"
        },
        plotOptions: {
          packedbubble: {
            minSize: "30%",
            maxSize: "100%",
            zMin: 0,
            zMax: 1000,
            lineWidth: 10,
            layoutAlgorithm: {
              splitSeries: false, //是否开启外边的大圆
              gravitationalConstant: 0.01
            },
            dataLabels: {
              enabled: true,
              format: "{point.name}",
              style: {
                color: "#ffffff",
                textOutline: "none",
                fontWeight: "normal",
                fontSize: "12px"
              }
            }
          }
        },
        series: [
          {
            name: "公益诉讼门户",
            data: [
              {
                name: "公益诉讼门户",
                value: 543
              }
            ]
          },
          {
            name: "电视台",
            data: [
              {
                name: "电视台",
                value: 431
              }
            ]
          },
          {
            name: "检察院内网",
            data: [
              {
                name: "检察院内网",
                value: 327
              }
            ]
          },
          {
            name: "微信",
            data: [
              {
                name: "微信",
                value: 432
              }
            ]
          },
          {
            name: "检察日报",
            data: [
              {
                name: "检察日报",
                value: 326
              }
            ]
          },
          {
            name: "检察网",
            data: [
              {
                name: "检察网",
                value: 322
              }
            ]
          }
        ]
      });
    },
    gohome() {
      this.$router.push({ path: "/home" });
    },
    // 统计渠道数量
    statistics_number() {
      let myChart = this.$echarts.init(
        document.getElementById("statistics_number")
      );
      myChart.setOption({
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b} : {c} ({d}%)"
        },
        calculable: true,
        series: [
          {
            name: "统计渠道数量",
            type: "pie",
            radius: [70, 110],
            center: ["50%", "50%"],
            roseType: "area",
            color: [
              "#6abeed",
              "#5ad3f0",
              "#77a8e4",
              "#6bcae4",
              "#8870c5",
              "#6abded",
              "#6bd0c9"
            ],
            data: [
              { value: 322, name: "监察网" },
              { value: 432, name: "微信" },
              { value: 431, name: "电视台" },
              { value: 327, name: "检察院内网" },
              { value: 326, name: "检查日报" },
              { value: 124, name: "正义网" },
              { value: 543, name: "公益诉讼门户" }
            ],
            label: {
              normal: {
                show: true,
                textStyle: {
                  fontSize: 14
                }
              }
            }
          },
          {
            type: "pie",
            zlevel: 1,
            silent: true,
            radius: ["78%", "76%"],
            hoverAnimation: false,
            color: "rgba(88,142,197,0.5)",
            // animation:false,    //charts3 no
            label: {
              normal: {
                show: false
              }
            },
            labelLine: {
              normal: {
                show: false
              }
            },
            data: [1]
          },
          {
            type: "pie",
            zlevel: 1,
            silent: true,
            radius: ["90%", "89%"],
            hoverAnimation: false,
            color: "rgba(44,94,112,0.5)",
            // animation:false,    //charts3 no
            label: {
              normal: {
                show: false
              }
            },
            labelLine: {
              normal: {
                show: false
              }
            },
            data: [1]
          }
        ]
      });
    },
    myChart1() {
      let myChart = this.$echarts.init(
        document.getElementById("myChart1"),
        "dark"
      );
      let option = {
        backgroundColor: "",
        //color: ["#37A2DA", "#67E0E3", "#FFD85C", "#FF9F7F", "#E062AE"],
        title: {
          text: "案情情况分析",
          top: 20,
          textStyle: {
            fontSize: "18"
          }
        },
        color: [
          "#00dc9b",
          "#0566d4",
          "#dbff0d",
          "#97adfc",
          "#0bca25",
          "#749f83",
          "#ca8622",
          "#bda29a",
          "#6e7074",
          "#546570",
          "#c4ccd3"
        ],
        legend: {
          bottom: 20,
          left: 0,
          type: "scroll"
        },
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b} : {c} ({d}%)"
        },
        textStyle: {
          fontSize: "10",
          fontFamily: "bold"
        },
        visualMap: {
          show: false,
          min: 80,
          max: 600,
          inRange: {
            colorLightness: [0, 1]
          }
        },
        series: [
          {
            name: "",
            type: "pie",
            radius: "50%",
            data: [
              { value: 335, name: "国有土地使用权" },
              { value: 310, name: "国有财产保护" },
              { value: 274, name: "生态资源与环境保护" },
              { value: 235, name: "食品与药品安全" },
              { value: 400, name: "英烈保护" }
            ],
            roseType: "radius",
            labelLine: {
              normal: {
                lineStyle: {
                  color: "rgba(255, 255, 255, 0.3)"
                },
                smooth: 0.2,
                length: 10,
                length2: 20
              }
            },
            label: {
              normal: {
                show: true,
                fontSize: 12,
                formatter: "{d}%"
              }
            }
          }
        ]
      };
      myChart.setOption(option);
    },
    myChart2() {
      let myChart = this.$echarts.init(
        document.getElementById("myChart2"),
        "dark"
      );
      let option = {
        backgroundColor: "",
        //color: ["#11ccd3"],
        color: ["#11c8d5"],
        title: {
          text: "近一月数据采集情况",
          top: 20,
          textStyle: {
            fontSize: "16"
          }
        },
        tooltip: {
          trigger: "axis"
        },
        grid: {
          top: "20%",
          left: "0%",
          right: "3%",
          bottom: "5%",
          containLabel: true
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: ["第一周", "第二周", "第三周", "第四周"],
          axisLabel: {
            fontSize: "12"
          },
          axisLabel: {
            color: "#21bffd"
          }
        },
        yAxis: {
          type: "value",
          axisLabel: {
            fontSize: "12",
            color: "#868686"
          }
        },
        series: [
          {
            name: "数据",
            type: "line",
            stack: "总量",
            data: [120, 132, 101, 134],
            areaStyle: {},
            smooth: true
          }
        ]
      };
      myChart.setOption(option);
    },
    myChart3() {
      let myChart = this.$echarts.init(
        document.getElementById("myChart3"),
        "dark"
      );
      myChart.setOption({
        backgroundColor: "",
        color: ["#e9dc81"],
        title: {
          text: "案件来源",
          textStyle: {
            fontSize: "16"
          },
          top: 20
        },
        tooltip: {},
        radar: {
          name: {
            textStyle: {
              fontSize: 12,
              color: "#04a8f2"
            },
            formatter: a => {
              return `${a}`;
            }
          },
          indicator: [
            { name: "行政执法单位", max: 6500 },
            { name: "互联网", max: 16000 },
            { name: "群众举报", max: 30000 },
            { name: "统一业务应用系统", max: 38000 },
            { name: "卫星影像", max: 52000 },
            { name: "其它", max: 25000 }
          ]
        },
        series: [
          {
            name: "",
            type: "radar",
            data: [
              {
                value: [5000, 14000, 28000, 31000, 42000, 21000],
                label: {
                  normal: {
                    show: true,
                    formatter: function(params) {
                      return params.value;
                    },
                    fontSize: 12,
                    color: "#04a8f2",
                    fontWeight: "bold"
                  }
                },
                itemStyle: {
                  color: "#e9dc81"
                }
              }
            ]
          }
        ]
      });
    },
    myChart7() {
      let myChart = this.$echarts.init(
        document.getElementById("myChart7"),
        "dark"
      );
      myChart.setOption({
        backgroundColor: "",
        color: ["#37A2DA", "#67E0E3", "#FFD85C", "#FF9F7F", "#E062AE"],
        title: {
          text: "案件统计",
          top: 20,
          textStyle: {
            fontSize: "16"
          }
        },
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b}: {c} ({d}%)"
        },
        legend: {
          bottom: 10,
          data: ["民事公益诉讼", "行政公益诉讼"],
          textStyle: {
            fontSize: 12
          }
        },
        series: [
          {
            name: "",
            type: "pie",
            radius: ["50%", "70%"],
            label: {
              normal: {
                show: true,
                position: "inner",
                fontSize: 12,
                formatter: "{b}\n{d}%"
              },
              emphasis: {
                show: true,
                textStyle: {
                  fontSize: "16",
                  fontWeight: "bold"
                }
              }
            },
            labelLine: {
              normal: {
                show: false
              }
            },
            data: [
              { value: 335, name: "民事公益诉讼" },
              { value: 310, name: "行政公益诉讼" }
            ]
          }
        ]
      });
    },
    myChart5() {
      let myChart = this.$echarts.init(
        document.getElementById("myChart5"),
        "dark"
      );
      myChart.setOption({
        backgroundColor: "",
        textStyle: {
          fontSize: 16
        },
        color: ["#4fdddb", "#6d5d87", "#38912e", "#bf5274", "#a1c108"],
        //color: ["#3398DB"],
        tooltip: {
          trigger: "axis",
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: "shadow" // 默认为直线，可选为：'line' | 'shadow'
          }
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "12%",
          containLabel: true
        },
        xAxis: [
          {
            type: "category",
            data: [
              "公\n安\n厅",
              "民\n政\n厅",
              "司\n法\n厅",
              "财\n政\n厅",
              "自\n然\n资\n源\n厅",
              "生\n态\n环\n境\n厅",
              "住\n房\n和\n城\n乡\n建\n设\n厅",
              "交\n通\n运\n输\n厅",
              "水\n利\n厅",
              "农\n牧\n厅",
              "商\n务\n厅",
              "文\n化\n和\n旅\n游\n厅",
              "卫\n生\n健\n康\n委\n员\n会",
              "退\n役\n军\n人\n事\n务\n厅",
              "审\n计\n厅",
              "市\n场\n监\n督\n管\n理\n局",
              "能\n源\n局",
              "林\n业\n和\n草\n原\n局",
              "地\n方\n金\n融\n监\n督\n管\n理\n局",
              "医\n疗\n保\n障\n局",
              "文\n物\n局",
              "药\n品\n监\n督\n管\n理\n局"
            ],
            splitNumber: 1,
            axisTick: {
              alignWithLabel: true
            },
            axisLabel: {
              textStyle: {
                fontSize: 10
              }
            }
          }
        ],
        yAxis: [
          {
            type: "value",
            axisLabel: {
              textStyle: {
                fontSize: 12
              }
            }
          }
        ],
        series: [
          {
            name: "食品药品安全",
            type: "bar",
            data: [
              4100,
              6100,
              8100,
              7500,
              7500,
              7500,
              7500,
              7500,
              7500,
              7500,
              7500,
              7500,
              7500,
              7500,
              7500,
              7500,
              7500,
              7500,
              7500,
              7500,
              7500,
              7500
            ]
          }
        ]
      });
    },
    myChart6() {
      let myChart = this.$echarts.init(
        document.getElementById("myChart6"),
        "dark"
      );
      myChart.setOption({
        backgroundColor: "",
        textStyle: {
          fontSize: 16
        },
        color: ["#4fdddb", "#6d5d87", "#38912e", "#bf5274", "#a1c108"],
        //color: ["#3398DB"],
        tooltip: {
          trigger: "axis",
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: "shadow" // 默认为直线，可选为：'line' | 'shadow'
          }
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "12%",
          containLabel: true
        },
        xAxis: [
          {
            type: "category",
            data: [
              "文\n书\n鉴\n定",
              "痕\n迹\n鉴\n定",
              "声\n像\n资\n料",
              "环\n境\n损\n害",
              "司\n法\n会\n计",
              "计\n算\n机\n鉴\n定",
              "建\n筑\n工\n程",
              "知\n识\n产\n权",
              "产\n品\n质\n量",
              "化\n工\n类",
              "资\n产\n评\n估",
              "农\n业\n类",
              "水\n产\n类",
              "林\n业\n类",
              "矿\n产\n类",
              "其\n他"
            ],
            splitNumber: 1,
            axisTick: {
              alignWithLabel: true
            },
            axisLabel: {
              textStyle: {
                fontSize: 10
              }
            }
          }
        ],
        yAxis: [
          {
            type: "value",
            axisLabel: {
              textStyle: {
                fontSize: 12
              }
            }
          }
        ],
        series: [
          {
            name: "食品药品安全",
            type: "bar",
            data: [
              4100,
              6100,
              8100,
              7500,
              7500,
              7500,
              7500,
              7500,
              7500,
              7500,
              7500,
              7500,
              7500,
              7500,
              7500,
              7500
            ]
          }
        ]
      });
    },
    myChart4() {
      let myChart = this.$echarts.init(
        document.getElementById("myChart4"),
        "dark"
      );
      myChart.setOption({
        backgroundColor: "",
        textStyle: {
          fontSize: 16
        },
        color: ["#4fa3af", "#6d5d87", "#38912e", "#bf5274", "#a1c108"],
        //color: ["#3398DB"],
        tooltip: {
          trigger: "axis",
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: "shadow" // 默认为直线，可选为：'line' | 'shadow'
          }
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "12%",
          containLabel: true
        },
        xAxis: [
          {
            type: "category",
            data: ["2016", "2017", "2018", "2019"],
            axisTick: {
              alignWithLabel: true
            },
            axisLabel: {
              textStyle: {
                fontSize: 12
              }
            }
          }
        ],
        yAxis: [
          {
            type: "value",
            axisLabel: {
              textStyle: {
                fontSize: 12
              }
            }
          }
        ],
        series: [
          {
            name: "食品药品安全",
            type: "bar",
            data: [4100, 6100, 8100, 7500]
          },
          {
            name: "国有土地使用权出让",
            type: "bar",
            data: [8000, 4500, 4600, 3800]
          },
          {
            name: "生态资源",
            type: "bar",
            data: [6300, 6400, 7800, 6200]
          },
          {
            name: "国有财产",
            type: "bar",
            data: [3800, 4100, 4200, 2500]
          },
          {
            name: "英烈权益",
            type: "bar",
            data: [4500, 3000, 4300, 5500]
          }
        ]
      });
    },
    myChart8() {
      let myChart = this.$echarts.init(
        document.getElementById("myChart8"),
        "dark"
      );
      let that = this;
      var size = [16, 40, 12, 13, 55, 18, 30, 50];

      const file = "/static/neimenggu.json";
      that.$axios.get(file).then(response => {
        this.$echarts.registerMap("neimenggu", response.data);
        myChart.setOption({
          backgroundColor: "",
          title: {
            text: "",
            textStyle: {
              fontSize: 16
            }
          },
          geo3D: {
            map: "neimenggu",
            height: 511,
            width: 690,
            label: {
              show: true,
              emphasis: {
                show: true
              },
              textStyle: {
                color: "#000",
                fontSize: 14,
                backgroundColor: "rgba(0,23,11,0)"
              }
            },
            viewControl: {
              zoomSensitivity: 0,
              panSensitivity: 0,
              rotateSensitivity: 0,
              alpha: 50,
              orthographicSize: 300
            },
            //shading :"color",
            emphasis: {
              //当鼠标放上去  地区区域是否显示名称
              label: {
                show: true,
                textStyle: {
                  color: "#000",
                  fontSize: 1,
                  backgroundColor: "rgba(0,23,11,0)"
                }
              }
            },
            roam: false, //是否允许缩放
            scaleLimit: {
              min: 1 //定义滚轮缩放的极限控制
            },
            itemStyle: {
              color: "#8df6ff",
              //areaColor: "rgb(141,245,255)",
              opacity: 1,
              borderWidth: 1,
              //borderColor: "rgb(62,215,213)"
              borderColor: "#759fd2"
            }
          },
          light: {
            //光照阴影
            main: {
              color: "#fff", //光照颜色
              intensity: 1.2, //光照强度
              //shadowQuality: 'high', //阴影亮度
              shadow: false, //是否显示阴影
              alpha: 55,
              beta: 10
            }
          },
          series: []
        });
      });
    },
    // 播放按钮---暂停,播放
    pauseClick() {
      if (this.pauseIcon == "el-icon-video-play") {
        this.pauseIcon = "el-icon-video-pause";
        this.commandShow = true;
      } else {
        this.pauseIcon = "el-icon-video-play";
        this.commandShow = false;
      }
    },
    rideo() {
      var certifySwiper = new Swiper("#certify .swiper-container", {
        watchSlidesProgress: true,
        slidesPerView: "auto",
        centeredSlides: true,
        loop: true,
        autoplay: 1,
        loopedSlides: 5,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        },
        pagination: {
          el: ".swiper-pagination"
          //clickable :true,
        },
        on: {
          progress: function(progress) {
            for (let i = 0; i < this.slides.length; i++) {
              var slide = this.slides.eq(i);
              var slideProgress = this.slides[i].progress;
              let modify = 1;
              if (Math.abs(slideProgress) > 1) {
                modify = (Math.abs(slideProgress) - 1) * 0.3 + 0.7;
              }
              let translate = slideProgress * modify * 270 + "px";
              let scale = 1 - Math.abs(slideProgress) / 5;
              let zIndex = 999 - Math.abs(Math.round(10 * slideProgress));
              slide.transform(
                "translateX(" + translate + ") scale(" + scale + ")"
              );
              slide.css("zIndex", zIndex);
              slide.css("opacity", 1);
              if (Math.abs(slideProgress) > 3) {
                slide.css("opacity", 0);
              }
            }
          },
          setTransition: function(transition) {
            for (var i = 0; i < this.slides.length; i++) {
              var slide = this.slides.eq(i);
              slide.transition(transition);
            }
          }
        }
      });
    },
    changeVideo(url) {
      // console.log(url);
      this.playerOptions = {
        //       playbackRates: [0.7, 1.0, 1.5, 2.0], //播放速度
        autoplay: true, //如果true,浏览器准备好时开始回放。
        muted: true, // 默认情况下将会消除任何音频。
        loop: true, // 导致视频一结束就重新开始。
        preload: "auto", // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: "zh-CN",
        aspectRatio: "16:9", //将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        sources: [
          {
            type: "video/mp4",
            src: url //你的视频地址（必填）
          }
        ],
        // width: document.documentElement.clientWidth,
        width: "1280px",
        poster: "poster.jpg", //你的封面地址
        notSupportedMessage: "此视频暂无法播放，请稍后再试", //允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controlBar: {
          timeDivider: true,
          durationDisplay: true,
          remainingTimeDisplay: true,
          fullscreenToggle: true //全屏按钮
        }
      };
    }
  }
};
</script>

<style scoped>
@import url("../assets/css3d/htmleaf-demo.css");
@import url("../assets/css3d/normalize.css");

.main {
  background: url("../assets/yin2.png") no-repeat;
  background-size: 100%;
  width: 2880px;
  height: 1080px;
  color: #ffffff;
}

.border {
  background: url("../assets/border3.png") no-repeat;
  background-size: 100% 300px;
  width: 100%;
  height: 300px;
  padding: 5px 5px;
}

.diqiu {
  background: url("../assets/diqiu.png") no-repeat;
  background-size: 334px 263px;
  background-position: center;
  width: 100%;
  height: 263px;
  padding: 5px 5px;
}
.title {
  font-size: 50px;
}

.myChart {
  /* border: #ffffff 2px dashed; */
  width: 96%;
  padding: 5px 30px;
}

.border img {
  width: 120px;
  margin-left: 10px;
}

.box-title {
  text-align: left;
  font-size: 18px;
  margin-top: 30px;
  margin-bottom: 30px;
  margin-left: 40px;
}

.group {
  background: url("../assets/img_product/group.png") no-repeat;
  width: 450px;
  height: 275px;
  padding-left: 20px;
  margin-left: 50px;
}

.groupnumber {
  color: #75eaff;
}

.groupcontent {
  color: #bccad4;
}

.home {
  position: absolute;
  left: 147px;
  top: 44px;
  width: 120px;
  height: 96px;
  cursor: pointer;
}

.chart1 {
  position: absolute;
  left: 792px;
  top: 169px;
  width: 436px;
  height: 86px;
  border: 0px solid #ffffff;
}

.chart2 {
  position: absolute;
  left: 1809px;
  top: 203px;
  width: 216px;
  height: 52px;
  border: 0px solid #ffffff;
}

.chart3 {
  position: absolute;
  left: 74px;
  top: 725px;
  width: 912px;
  height: 277px;
  border: 0px solid #ffffff;
  font-size: 14px;
  color: #9fbbd0;
  text-align: center;
}

.chart4 {
  position: absolute;
  left: 125px;
  top: 760px;
  width: 784px;
  height: 225px;
}

.chart5 {
  position: absolute;
  left: 1028px;
  top: 701px;
  width: 834px;
  height: 290px;
  border: 0px solid #ffffff;
}

.chart6 {
  position: absolute;
  left: 1923px;
  top: 497px;
  width: 543px;
  height: 195px;
  border: 0px solid #ffffff;
}

.chart7 {
  position: absolute;
  left: 2398px;
  top: 806px;
  width: 165px;
  height: 208px;
  border: 0px solid #ffffff;
}

.chart8 {
  position: absolute;
  left: 2603px;
  top: 812px;
  width: 138px;
  height: 188px;
  border: 0px solid #ffffff;
}

.chart3part2 {
  position: absolute;
  left: 120px;
  top: 140px;
  font-size: 14px;
  color: #9fbbd0;
}
/* 统计渠道数量 */
.statistics_number {
  position: absolute;
  width: 370px;
  height: 300px;
  left: 365px;
  top: 160px;
  /* background: #75eaff; */
}
/* 统计渠道数量左边 */
.statistics_numberleft {
  position: absolute;
  width: 300px;
  height: 330px;
  left: 70px;
  top: 160px;
  /* background: #75eaff; */
}

.video {
  position: absolute;
  width: 900px;
  height: 420px;
  left: 80px;
  top: 600px;
  /* background: #29f1f2; */
}
/* 轮播图的总宽度 */
#certify {
  width: 860px;
}
#certify .swiper-slide {
  width: 460px;
  height: 368px;
  background: rgba(255, 255, 255, 0) !important;
  box-shadow: 0 8px 30px #001c32;
}
</style>
